import AuthProvider from "./auth"
import BannerProvider from "./banner"
import PermissionProvider from "./permissions"
import QueryProvider from "./query"

const AppProviders: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <BannerProvider>
      <QueryProvider>
        <AuthProvider>
          <PermissionProvider>{children}</PermissionProvider>
        </AuthProvider>
      </QueryProvider>
    </BannerProvider>
  )
}

export default AppProviders
